// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconAgentPath = 'M10 17.361a6 6 0 0 1-5.59-3.65 7.287 7.287 0 0 0 2.81 1.43 1.51 1.51 0 0 0 1.28.72h1a1.5 1.5 0 1 0 0-3h-1a1.424 1.424 0 0 0-.88.3 5 5 0 0 1-3.35-3 6.888 6.888 0 0 0 4-2.86 9.7 9.7 0 0 0 7.2 3H16v1.3a5.87 5.87 0 0 1-5.978 5.76H10Zm0-15c.335.002.67.032 1 .09a5.75 5.75 0 0 1 5 5.63v.28h-.53A7.2 7.2 0 0 1 9 4.901a.999.999 0 0 0-1-.54c-.404.04-.744.321-.86.71A4.771 4.771 0 0 1 4 8.191v-.11a5.87 5.87 0 0 1 6-5.72Zm1.36-1.88A7.752 7.752 0 0 0 10 .361a7.87 7.87 0 0 0-8 7.72v3.56a8 8 0 0 0 16 0v-3.56a7.72 7.72 0 0 0-6.64-7.6Z';
var IconAgent = baseIcon('IconAgent', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconAgentPath
});
export default IconAgent;
//# sourceMappingURL=index.js.map